import React, { useEffect, useState, useRef } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Message,
  Checkbox,
  Card,
  Pagination,
  DatePicker,
  NumberPicker,
  Form,
} from '@alifd/next';
import { message, Space, Typography } from 'antd';
import moment from 'moment';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const PublicInformationSetting = ({ showButton }) => {
  const uploadRef = useRef(null);
  const uploadAnnouncement = useRef(null);
  const announcement = client.service('announcement');
  const uploads = client.service('uploads');
  const [communityDataArr, setCommunityDataArr] = useState([]);
  const [userName, setUserName] = useState('');
  const communityData = client.service('communityData');
  const [isUpdate, setIsUpdate] = useState(false);
  const [announcementDialog, setAnnouncementDialog] = useState(false);
  const [announcementObject, setAnnouncementObject] = useState({});
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [disable, setDisable] = useState(true);
  const [uploadAnnouncementPath, setUploadAnnouncementPath] = useState('');
  const [uploadAnnouncementData, setUploadAnnouncementData] = useState(null);
  useEffect(() => {
    (async () => {
      const result = await communityData.find({ query: {} });
      setCommunityDataArr(result.data[0]);
      const userData = await client.reAuthenticate();
      setUserName(userData.user.name);
    })();
  }, [isUpdate, communityData]);

  return (
    <>
      {' '}
      {/* 公共設施參數設定 */}
      <Card free className={styles.publicSetting}>
        <Card.Content>
          <h3>公共設施使用管理辦法</h3>
          <div style={{ marginBottom: 10 }}>
            1.住戶可提早
            <NumberPicker
              disabled={disable}
              defaultValue={0}
              min={0}
              value={
                communityDataArr?.publicAppointmentAdvanceTime
                  ? communityDataArr.publicAppointmentAdvanceTime / 60000
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentAdvanceTime = value * 60000;
                setCommunityDataArr(newObject);
              }}
            />
            分鐘進入公設。
          </div>

          <div style={{ marginBottom: 10 }}>
            2.住戶可提早
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentCheckTime
                  ? communityDataArr.publicAppointmentCheckTime / 60000
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentCheckTime = value * 60000;
                setCommunityDataArr(newObject);
              }}
            />
            分鐘報到（防止公設預約時間被取消）。
          </div>
          <div style={{ marginBottom: 10 }}>
            3.住戶最晚可超過
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentDelayTime
                  ? communityDataArr.publicAppointmentDelayTime / 60000
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentDelayTime = value * 60000;
                setCommunityDataArr(newObject);
              }}
            />
            分鐘離開公設。
          </div>
          <div style={{ marginBottom: 10 }}>
            4.住戶最晚可於預約時間前
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentCancelTime
                  ? communityDataArr.publicAppointmentCancelTime / 60000
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentCancelTime = value * 60000;
                setCommunityDataArr(newObject);
              }}
            />
            分鐘取消預約，超過時間則不可取消預約。(含住戶推播通知)
          </div>
          <div style={{ marginBottom: 10 }}>
            5.住戶最晚可於預約時間後
            <NumberPicker
              disabled={disable}
              min={0}
              defaultValue={0}
              value={
                communityDataArr?.publicAppointmentLatestTime
                  ? communityDataArr.publicAppointmentLatestTime / 60000
                  : 0
              }
              onChange={(value) => {
                const newObject = { ...communityDataArr };
                newObject.publicAppointmentLatestTime = value * 60000;
                setCommunityDataArr(newObject);
              }}
            />
            分鐘進入公設，若無進入將取消預約。(含住戶推播通知)
          </div>
          <div style={{ marginBottom: 10 }}>
            <Space wrap>
              <Button
                disabled={disable}
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadRef.current.click();
                }}
              >
                {communityDataArr?.publicFile?.name ? '更換檔案' : '檔案上傳'}
              </Button>
              {uploadData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadData.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      setUploadData(null);
                      setUploadPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    清除
                  </Button>
                </>
              )}
              {!uploadData && communityDataArr?.publicFile?.name && (
                <>
                  <Typography.Text type="secondary">
                    {communityDataArr?.publicFile?.name}
                  </Typography.Text>
                  <Button
                    disabled={disable}
                    text
                    onClick={() => {
                      const newObject = { ...communityDataArr };
                      newObject.publicFile = null;
                      setCommunityDataArr(newObject);
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    清除
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadRef}
              type="file"
              id="upload"
              value={uploadPath || ''}
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadData(file);
                setUploadPath(e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: 10, textAlign: 'right' }}>
            {showButton !== false && (
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  setAnnouncementDialog(true);
                  const defaultValue = {
                    title: '更新公共設施管理制度',
                    announcementTime: moment(),
                    content: `1.住戶可提早${
                      communityDataArr.publicAppointmentAdvanceTime / 60000
                    }分鐘進入公設。\n2.住戶可提早${
                      communityDataArr.publicAppointmentCheckTime / 60000
                    }分鐘報到（防止公設預約時間被取消）。\n3.住戶最晚可超過${
                      communityDataArr.publicAppointmentDelayTime / 60000
                    }離開公設。\n4.住戶最晚可於預約時間前${
                      communityDataArr.publicAppointmentCancelTime / 60000
                    }分鐘取消預約，超過時間則不可取消預約。\n5.住戶最晚可於預約時間後${
                      communityDataArr.publicAppointmentCancelTime / 60000
                    }分鐘進入公設，若無進入將取消預約。`,
                  };
                  setAnnouncementObject(defaultValue);
                }}
              >
                發佈公告
              </Button>
            )}

            <Button
              type="secondary"
              onClick={async () => {
                setDisable((pre) => !pre);
                console.log(communityDataArr);
                if (disable === false) {
                  try {
                    let NewPublicFile = communityDataArr?.publicFile?.name
                      ? communityDataArr.publicFile
                      : {};
                    if (communityDataArr?.publicFile?.name && uploadData) {
                      await uploads.remove(communityDataArr.publicFile.id);
                    }
                    if (uploadData) {
                      const body = new FormData();
                      body.append('files', uploadData);
                      const res = await fetch(
                        '/newUploads?type=communityData',
                        {
                          method: 'POST',
                          body,
                          headers: {
                            authorization: window.localStorage['feathers-jwt'],
                          },
                        }
                      );
                      const { showPath, _id } = await res.json();
                      NewPublicFile = {
                        path: showPath,
                        name: uploadData.name,
                        id: _id,
                      };
                    }
                    await communityData.patch(communityDataArr._id, {
                      ...communityDataArr,
                      publicFile: NewPublicFile,
                    });
                    setIsUpdate((pre) => !pre);
                    message.success('已更新設定參數');
                  } catch (error) {
                    message.error('更新失敗');
                  }
                }
              }}
            >
              {disable === true ? '編輯' : '完成'}
            </Button>
          </div>
        </Card.Content>
      </Card>
      {/* 發佈公告 */}
      <Dialog
        hasMask
        className={styles.announcementDialog}
        visible={announcementDialog}
        onOk={async () => {
          // form1.submit();
          let newAnnounceFile = {};
          if (uploadAnnouncementData) {
            const body = new FormData();
            body.append('files', uploadAnnouncementData);
            const res = await fetch('/newUploads?type=announcement', {
              method: 'POST',
              body,
              headers: {
                authorization: window.localStorage['feathers-jwt'],
              },
            });

            newAnnounceFile = await res.json();
          }
          console.log(newAnnounceFile);
          try {
            announcement.create({
              ...announcementObject,
              createdTime: moment().valueOf(),
              updatedTime: moment().valueOf(),
              type: '一般公告',
              fileType: 'file',
              files: [{ response: { ...newAnnounceFile } }],
              allows: [],
              broadcastStatus: false,
              broadcastGroupId: null,
              calendarStatus: false,
              calendarId: null,
              MessageStatus: false,
              checkedStatus: false,
              announcer: userName,
            });
            setAnnouncementDialog(false);
            message.success('新增成功');
          } catch (error) {
            console.log(error);
          }
        }}
        onCancel={() => {
          setAnnouncementDialog(false);
        }}
        onClose={() => {
          setAnnouncementDialog(false);
        }}
      >
        <Form
          //   form={form1}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          //   onFinish={onFinishAnnouncement}
          autoComplete="off"
        >
          <h3>新增公告</h3>
          <Form.Item
            label="發佈時間"
            name="announcementTime"
            // required
            // requiredMessage="請選擇發佈時間"
          >
            <DatePicker
              showTime={{ format: 'HH:mm:ss' }}
              value={announcementObject.announcementTime}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.announcementTime = moment(value).valueOf();
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item
            label="標題"
            name="title"
            required
            requiredMessage="請輸入標題"
          >
            <Input
              value={announcementObject.title}
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.title = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>

          <Form.Item
            label="內容"
            name="content"
            required
            requiredMessage="請輸入內容"
          >
            <Input.TextArea
              value={announcementObject.content}
              aria-label="TextArea"
              onChange={(value) => {
                const newObject = { ...announcementObject };
                newObject.content = value;
                setAnnouncementObject(newObject);
              }}
            />
          </Form.Item>
          <Form.Item label="檔案上傳">
            <Space wrap>
              <Button
                style={{ marginRight: 10 }}
                onClick={() => {
                  uploadAnnouncement.current.click();
                }}
              >
                檔案上傳
              </Button>
              {uploadAnnouncementData && (
                <>
                  <Typography.Text type="secondary">
                    {uploadAnnouncementData.name}
                  </Typography.Text>
                  <Button
                    text
                    onClick={() => {
                      setUploadAnnouncementData(null);
                      setUploadAnnouncementPath('');
                    }}
                    style={{ opacity: 0.45 }}
                  >
                    清除
                  </Button>
                </>
              )}
            </Space>
            <input
              ref={uploadAnnouncement}
              type="file"
              id="upload"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                setUploadAnnouncementData(file);
                setUploadAnnouncementPath(e.target.value);
              }}
            />
          </Form.Item>
        </Form>
      </Dialog>
    </>
  );
};
export default PublicInformationSetting;
